// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { createAsyncAction } from 'typesafe-actions';
import { Support } from '../../../types/Model';

export interface SupportRequestPayload { }

export interface SupportSuccessPayload {
  list: Support[];
}

export interface SupportFailPayload {
  error: Error;
}

const getSupportDataActions = createAsyncAction(
  'elearning/GET_SUPPORT_DATA',
  'elearning/GET_SUPPORT_DATA_SUCCESS',
  'elearning/GET_SUPPORT_DATA_FAIL'
)<
  SupportRequestPayload,
  SupportSuccessPayload,
  SupportFailPayload
>();

export { getSupportDataActions as default }
